import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { logoText, sidebarIcon } from 'assets/images';
import Sidebar from 'components/Navigation/Sidebar/Sidebar';
import Navbar from 'components/Navigation/Navbar';
import LanguageSwitcher from 'components/Navigation/Languages';
import useIsMobile from 'utils/useIsMobile';

import styles from './home.module.scss';
import './mobileSidebar.css';

const Home = ({ children }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return isMobile ? (
    <>
      <div className="header">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            onClick={toggleSidebar}
            className="toggle-button">
            <img src={sidebarIcon} alt="fileIcon" />
          </button>
          <img className="logo" alt="logo" src={logoText} loading="lazy" />
        </div>
        <div>
          <LanguageSwitcher />
        </div>
      </div>
      <div className={`sidebar-mobile ${isOpen ? 'open' : ''}`}>
        <div className="buttons">
          <Link to="/references" style={{ textDecoration: 'none' }}>
            <div
              className={clsx(
                'navbarReferences',
                location.pathname === '/references' && styles.active,
              )}>
              <div className={styles.navbarReferencesTitle}>
                {t('global:navbar.manual')}
              </div>
            </div>
          </Link>

          <Link to="/qr" style={{ textDecoration: 'none' }}>
            <div
              className={clsx(
                'navbarReferences',
                location.pathname === '/qr' && styles.active,
              )}>
              <div className={styles.navbarReferencesTitle}>
                {t('qr:header')}
              </div>
            </div>
          </Link>
        </div>
        <hr style={{ width: '90%', color: '#DCE1E5', marginTop: '15px' }} />
        <div className="homeSidebar">
          <Sidebar />
        </div>
      </div>

      {isOpen && (
        <div aria-hidden className="backdrop" onClick={toggleSidebar} />
      )}
      <div className="homeContent">{children}</div>
    </>
  ) : (
    <div className={styles.home}>
      <div className={styles.homeNavbar}>
        <Navbar />
      </div>
      <div className={styles.homeContainer}>
        <div className={styles.homeSidebar}>
          <Sidebar />
        </div>
        <div className={styles.homeContent}>{children}</div>
      </div>
    </div>
  );
};

export default Home;
